/*
  munchief-pincode — delivery check for the product page.

  Every valid Indian pincode (six digits, not starting with 0) is shown as
  serviceable — Pan India delivery. The estimate is 3–5 business days from
  today, Sundays excluded.
*/
(function () {
  var DAY = 24 * 60 * 60 * 1000;

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    while (days > 0) {
      d = new Date(d.getTime() + DAY);
      if (d.getDay() !== 0) days -= 1;
    }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function init(form) {
    if (form.dataset.pincodeReady) return;
    form.dataset.pincodeReady = 'true';
    var input = form.querySelector('.pincode-form__input');
    var status = form.parentElement.querySelector('.pincode-form__status');
    if (!input || !status) return;

    function show(message, ok) {
      status.textContent = message;
      status.dataset.state = ok ? 'ok' : 'error';
      status.hidden = false;
    }

    input.addEventListener('input', function () { status.hidden = true; });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var pin = input.value.trim();
      if (!/^[1-9]\d{5}$/.test(pin)) {
        show('Enter a valid 6-digit pincode.', false);
        return;
      }
      var now = new Date();
      show('Delivery available. Estimated delivery ' + fmt(addBusinessDays(now, 3)) + ' – ' + fmt(addBusinessDays(now, 5)) + '.', true);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.pincode-form').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
